import React from 'react'
import {useNavigate, useRouteError} from "react-router-dom"
import Button from "../components/generic/buttons/Button"

export default function ErrorPage() {

  const error: any = useRouteError()
  const navigate = useNavigate()

  const renderErrorContent = () => {
    switch (error.status) {
      case 404:
        return (
          <>
            <p className={`error-page__message`}>Страница не найдена</p>
            <Button onClick={() => navigate('/')}>Перейти на главную</Button>
          </>
        )
      default:
        return (
          <>
            <p className={`error-page__message`}>{error.statusText || error.message}</p>
          </>
        )
    }
  }

  return(
    <>
      <div className="error-page">
        <div className={'error-page__container'}>
          <h1 className={'error-page__status'}>{error.status}</h1>
          <div className={'error-page__content'}>
            {renderErrorContent()}
          </div>
        </div>
      </div>
    </>
  )
}